<template>
  <iframe
    id="simulation-report"
    :src="reportUrl"
    style="width: 100%; border: 1px solid #fff"
    :style="{ height: pageHeight }"
  ></iframe>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'simulation-report',
  data() {
    return {
      windowHeight: 0,
      reportTypes: {
        simulation: 'report-inbox',
        annual: 'annual-report-inbox',
      },
      teamNameKeyMap: {
        andrews: 1,
        baldwin: 2,
        chester: 3,
        digby: 4,
        erie: 5,
        ferris: 6,
      },
    };
  },

  methods: {},
  computed: {
    ...mapState({
      baseUrl: (state) => state.Reports.platform.baseUrl,
      token: (state) => state.Reports.platform.token,
      stskey: (state) => state.userData.studentToSimKey,
    }),
    reportUrl() {
      const teamParam = this.$route.params.team
        ? `&teamNameKey=${this.teamNameKeyMap[this.$route.params.team]}`
        : '';
      return `${this.baseUrl}/${this.reportTypes[this.$route.params.reportType]}?token=${
        this.token
      }&stskey=${this.stskey}${teamParam}`;
    },
    pageHeight() {
      return `${this.windowHeight}px`;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (typeof to.meta.title == 'function') {
      document.title = to.meta.title(to);
    } else {
      document.title = to.meta.title;
    }
    next();
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowHeight = window.innerHeight;
      });
    });
  },
};
</script>
